<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Etikett &amp; Tooltip
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Formetiketter med ett valfritt informationsikon-tooltip. Hovra på ikonen
      för att se förklaringen.
    </p>

    <PreviewBox label="Etikett med tooltip — hovra">
      <div class="flex flex-col gap-4">
        <!-- Label only -->
        <div>
          <span
            class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] tracking-[0.8px] uppercase"
            >Hydrering</span
          >
        </div>
        <!-- Label + tooltip -->
        <div class="flex items-center gap-1.5">
          <span
            class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] tracking-[0.8px] uppercase"
            >Salt</span
          >
          <div
            class="relative"
            @mouseenter="showTooltip = true"
            @mouseleave="showTooltip = false"
          >
            <Info :size="14" color="#a0b0ae" class="cursor-default" />
            <div
              v-if="showTooltip"
              class="absolute left-1/2 -translate-x-1/2 bottom-full mb-1.5 z-50 px-3 py-2 rounded-xl font-[Plus_Jakarta_Sans] text-[12px] text-white leading-[1.5] whitespace-nowrap pointer-events-none"
              style="background: rgba(25, 28, 30, 0.92)"
            >
              Typisk brödrecept: 1.8–2.2 %
            </div>
          </div>
        </div>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Info } from "lucide-vue-next";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex items-center gap-1.5">
  <span class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] tracking-[0.8px] uppercase">
    Etikett
  </span>
  <div class="relative" @mouseenter="show = true" @mouseleave="show = false">
    <Info :size="14" color="#a0b0ae" class="cursor-default" />
    <div
      v-if="show"
      class="absolute left-1/2 -translate-x-1/2 bottom-full mb-1.5 z-50 px-3 py-2 rounded-xl
             font-[Plus_Jakarta_Sans] text-[12px] text-white whitespace-nowrap pointer-events-none"
      style="background: rgba(25,28,30,0.92)"
    >
      Hjälptexten visas här
    </div>
  </div>
</div>`;
const cssCode = `/* Etikett */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 12px;
letter-spacing: 0.8px;
text-transform: uppercase;
color: #6c7a77;

/* Info-ikon */
width: 14px;
height: 14px;
color: #a0b0ae;

/* Tooltip */
background: rgba(25,28,30,0.92);
border-radius: 12px;   /* rounded-xl */
padding: 8px 12px;
font-size: 12px;
color: white;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const showTooltip = ref(false);
</script>
